/* Marinelie — Hero-Countdown.
   Zielzeitpunkt kommt serverseitig aus dem Section-Setting
   (data-countdown-at, ISO 8601); hier wird nur heruntergezaehlt. */
(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function init() {
    document.querySelectorAll('[data-ml-hero-countdown]').forEach(function (out) {
      var target = Date.parse(out.getAttribute('data-countdown-at') || '');
      if (isNaN(target)) {
        out.textContent = '';
        return;
      }

      var timer = null;

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          out.textContent = '00D 00:00:00';
          if (timer) window.clearInterval(timer);
          return;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        var r = s % 60;
        out.textContent = pad(d) + 'D ' + pad(h) + ':' + pad(m) + ':' + pad(r);
      }

      tick();
      timer = window.setInterval(tick, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
